var angular = require('angular');
var moment = require('js/lib/moment');

var StopLocation = require('./stopLocation');
var Count = require('./count');
var toDate = require('./util').toDate;
var formatPhone = require('js/lib/util').formatPhone;
var delayMinutes = require('js/lib/util').delayInMinutes;
var delayHuman = require('js/lib/util').delayForHumans;
var aggregateProducts = require('js/lib/util').aggregateProductsForCustomers;

function Route(route, customers) {
  angular.extend(this, route);
  if (this.estimatedTimestampStart === this.estimatedTimestampStop) {
    this.estimatedTimestampStart = toDate(this.estimatedTimestampStart);
    this.estimatedTimestampStop = null;
  } else {
    this.estimatedTimestampStart = toDate(this.estimatedTimestampStart);
    this.estimatedTimestampStop = toDate(this.estimatedTimestampStop);
  }
  this.timestampStart = toDate(this.timestampStart);
  this.timestampStop = toDate(this.timestampStop);
  this.timestampLoadConfirmed = toDate(this.timestampLoadConfirmed);
  this.reserved = this.type === 1;
  this.stopLocations = getStopLocations(this, customers);
  this.updateCustomersRouteNameAndColor();
  angular.extend(this, new Count(this.stopLocations));
  if (customers && customers.length > 0) {
    this.customerTimeWindows = findCustomerTimeWindows(customers);
    this.customerCount = this.countCustomersNotCancelled();
    this.products = aggregateProducts(customers);
  } else {
    this.customerTimeWindows = route.customerTimeWindows || [];
    this.products = {};
  }
}

var getStopLocations = function(route, customers) {
  var stops = {};

  customers.forEach(function(customer) {
    if (stops[customer.stopLocationId]) {
      stops[customer.stopLocationId].addCustomer(customer);
    } else {
      stops[customer.stopLocationId] = new StopLocation(customer, route);
    }
  });

  return Object.keys(stops)
    .map(function(id) {
      return stops[id];
    })
    .sort(function(stop1, stop2) {
      return stop1.routeSequence - stop2.routeSequence;
    });
};

var findCustomerTimeWindows = function(customers) {
  var timeWindows = {};

  customers.forEach(function(customer) {
    var deliveryWindow = customer.deliveryWindow();
    if (deliveryWindow) {
      timeWindows[deliveryWindow] = deliveryWindow;
    }
  });

  return Object.keys(timeWindows);
};

Route.prototype.customers = function() {
  return this.stopLocations.reduce(function(customers, stopLocation) {
    return customers.concat(stopLocation.customers);
  }, []);
};

Route.prototype.deliveries = function() {
  return this.customers().reduce(function(deliveries, customer) {
    return deliveries.concat(customer.deliveries);
  }, []);
};

Route.prototype.updateCustomersRouteNameAndColor = function() {
  this.customers().forEach(function(customer) {
    customer.routeName = this.name;
    customer.routeColor = this.color;
  }, this);
};

Route.prototype.findStopLocation = function(stopLocationId) {
  return this.stopLocations.filter(function(stopLocation) {
    return stopLocation.id === stopLocationId;
  })[0];
};

Route.prototype.sortStopLocations = function() {
  return this.stopLocations.sort(function(stop1, stop2) {
    return stop1.routeSequence - stop2.routeSequence;
  });
};

Route.prototype.updateRouteOptimizationStatus = function(statusId) {
  this.optimizationStatus = statusId;
};

Route.prototype.countDeliveries = function(status) {
  return this.customers().reduce(function(count, customer) {
    return count + (status ? customer.findDeliveries(status) : customer.deliveries).length;
  }, 0);
};

Route.prototype.resetStats = function() {
  this.length = 0;
  this.durationDriving = 0;
  this.durationTotal = 0;
  this.estimatedTimestampStart = null;
  this.estimatedTimestampStop = null;
};

Route.prototype.validStats = function() {
  return this.durationTotal || ! this.stopLocations.length;
};

Route.prototype.updateDriverPosition = function(latitude, longitude) {
  this.driverPositionLatitude = latitude;
  this.driverPositionLongitude = longitude;
  this.driverPositionTimestamp = new Date();
};

Route.prototype.noGPS = function(mapContext) {
  // Check if route started long time ago - driver did not finish the route and we don't expect GPS/device to still be on
  var startedLongTimeAgo = moment().isAfter(moment(this.timestampStart).add(12, 'h'));

  var ts = this.driverPositionTimestamp;
  return ! ts || (moment(ts).isBefore(moment().subtract(5, 'minutes')) && (mapContext || ! startedLongTimeAgo));
};

Route.prototype.driverPositionIsRecent = function() {
  return ! this.noGPS(true);
};

Route.prototype.estimateOutsideDeliveryWindow = function() {
  return this.customers().some(function(customer) {
    return customer.estimateOutsideDeliveryWindow();
  });
};

Route.prototype.delayInMinutes = function() {
  var lastCustomer;
  var lastRouteSequence = 0;

  if (! this.timestampStart) {
    return delayMinutes(new Date(), this.estimatedTimestampStart);
  }

  if (this.timestampStop) {
    return delayMinutes(this.timestampStop, this.estimatedTimestampStop);
  }

  this.stopLocations.forEach(function(stop) {
    stop.customers.forEach(function(customer) {
      if (customer.routeSequence > lastRouteSequence && customer.deliveryStatusTimestamp()) {
        lastCustomer = customer;
        lastRouteSequence = customer.routeSequence;
      }
    });
  });

  if (lastCustomer) {
    return delayMinutes(lastCustomer.deliveryStatusTimestamp(), lastCustomer.estimatedTimestampDone);
  } else if (this.timestampStart) {
    return delayMinutes(this.timestampStart, this.estimatedTimestampStart);
  }
};

Route.prototype.delayForHumans = function() {
  return delayHuman(this.delayInMinutes());
};

Route.prototype.nameAndDriver = function(drivers, noPhone) {
  var driverName = this.driverName(drivers, noPhone);
  return driverName ? this.name + ' - ' + driverName : this.name;
};

Route.prototype.driverName = function(drivers, noPhone) {
  var driver = drivers[this.driverUsername];

  if (! driver) return '';

  var driverShortName = (driver.firstName ? driver.firstName : driver.name);

  if (! driver.phone || noPhone) return driverShortName;

  return driverShortName + ' (' + formatPhone(driver.phone) + ')';
};

module.exports = Route;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/route.js
 ** module id = 32
 ** module chunks = 1
 **/